export const CMS_MODULE_OPTIONS = 'CMS_MODULE_OPTIONS';